module.exports = __webpack_public_path__ + "static/img/top_bg.7cd7a2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/top_bg.png
// module id = 91Xn
// module chunks = 16